import * as members from '../privates/privateMembers';
import platformUtils from '../privates/platformUtils';
import BaseEvents from '../namespaces/events';
import _ from 'lodash';
import reporter from '../privates/reporter';

const WIXCODE_APP_DEFINITION = '675bbcef-18d8-41f5-800e-131ec9e08762';
class Events extends BaseEvents {
    constructor(appDefId) {
        super(appDefId);
        _.bindAll(this, ['setStaticEventHandlers']);
    }
    setStaticEventHandlers(eventHandlers, contextId) {
        const appDefId = members._appDefId.get(this);
        if (members._appDefId.get(this) === WIXCODE_APP_DEFINITION) {
            platformUtils.setStaticEventHandlers(eventHandlers, contextId);
        } else {
            const errorMessage = `app - ${appDefId}, should not use events - its for wixCode app only.`;
            reporter.reportSdkError(errorMessage);
        }
    }
}

export default Events;
